import { api } from "./api";

export const subjectList = async (addUrl=``) => {
    return await api.get(`/subjects?${addUrl}`); 
};

export const subjectAdd = async (data) => {
  return await api.post('/subject/add', data);
};

export const subjectDelete = async (id) => {  
  return await api.post(`/subject/delete`,{id});
}

export const subjectUpdate = async (data) => {
  return await api.post('/subject/update', data); 
};


//  --------------
export const getSbjById = async (id) => {
  return await api.get(`/courses/info/${id}`)
}

